export default __webpack_public_path__ + "cover.42ab449f6d8161d24ef4cd7bbeae0dca.jpg"